var _defs, _style;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCap(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 800,
    height: 800,
    viewBox: "0 0 24 24",
    fill: "none",
    id: "svg3",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", {
    id: "defs3"
  })), /*#__PURE__*/React.createElement("g", {
    id: "g3",
    transform: "matrix(1.1419567,0,0,1.1419567,-1.7034909,0.45569526)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "path3-9",
    style: {
      fill: "#daa520",
      fillOpacity: 0.466667,
      stroke: "#daa520",
      strokeWidth: 0.741204,
      strokeDasharray: "none",
      strokeOpacity: 1
    },
    d: "m 5.4555261,11.645536 v 3.072946 c 0,0.604352 0.470735,1.17021 1.2951772,1.463033 1.3728113,0.487499 3.5701747,1.159789 5.2492937,1.159789 1.679119,0 3.876455,-0.67229 5.249294,-1.159789 0.824415,-0.292823 1.295178,-0.858681 1.295178,-1.463033 v -3.072946 h -0.482343 l -4.016395,1.931701 c -1.328525,0.399364 -2.762847,0.399364 -4.0913605,0 L 5.9379243,11.645536 Z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "m 9.78272,3.49965 c 1.42098,-0.6662 3.01348,-0.6662 4.43448,0 l 6.6912,3.13699 c 1.4555,0.68235 1.4555,3.04441 0,3.72676 l -6.6911,3.137 c -1.421,0.6661 -3.0135,0.6661 -4.43449,0 L 3.0916,10.3634 c -1.45547,-0.68239 -1.45546,-3.04445 0,-3.72681 z",
    stroke: "#1C274D",
    strokeWidth: 1.5,
    id: "path1",
    style: {
      stroke: "#daa520",
      strokeWidth: 0.99,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M 1.9867298,8.4984198 V 13.99842",
    stroke: "#1C274D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    id: "path2",
    style: {
      stroke: "#daa520",
      strokeWidth: 0.99,
      strokeDasharray: "none",
      strokeOpacity: 1
    }
  })), _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css",
    id: "style1"
  }, "\n\t.st0{fill:#000000;}\n")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCap);
export default __webpack_public_path__ + "static/media/cap.88d60413d4144d41073a5ec356d42e7e.svg";
export { ForwardRef as ReactComponent };